import { log } from '../../services/utils';

import { controller } from '../../contexts/ContactsContext';

import { noraApiRequest } from './';

export const getContactList = async () => {
	log( '* get contact list' );
	const { data } = await noraApiRequest( {
		url: '/contacts',
		signal: controller.signal
	} );

	return data;
};

export const getContact = async id => {
	log( '* get contact' );
	const { data } = await noraApiRequest( {
		url: `/contacts/${ id }`,
		signal: controller.signal
	} );

	return data;
};

export const createContact = async data => {
	log( '* create contact' );
	const response = await noraApiRequest( {
		method: 'POST',
		url: '/contacts',
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const updateContact = async data => {
	log( '* update contact' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: '/contacts',
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const deleteContact = async id => {
	log( '* delete contact' );
	const response = await noraApiRequest( {
		method: 'DELETE',
		url: `/contacts/${ id }`,
		signal: controller.signal
	} );

	return response.data;
};

export const updateContactPhoto = async ( id, photoId ) => {
	log( '* update contact photo' );
	const response = await noraApiRequest( {
		method: 'PATCH',
		url: `/contacts/${ id }/photo/${ photoId }`,
		signal: controller.signal
	} );

	return response.data;
};

export const exportContactList = async ids => {
	log( '* export contact list' );
	const response = await noraApiRequest( {
		method: 'POST',
		url: '/contacts/export',
		data: { ids },
		signal: controller.signal
	} );

	return response.data;
};

export const getContactTags = async () => {
	log( '* lookup contact tags' );
	const { data } = await noraApiRequest( {
		url: '/contacts/labels',
		signal: controller.signal
	} );

	return data;
};

/* credentials */

export const getCredentialsList = async contactId => {
	log( '* get credentials list' );
	const { data } = await noraApiRequest( {
		url: `/contacts/${ contactId }/credentials`,
		signal: controller.signal
	} );

	return data;
};

export const createCredential = async ( contactId, data ) => {
	log( '* create contact' );
	const response = await noraApiRequest( {
		method: 'POST',
		url: `/contacts/${ contactId }/credentials`,
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const updateCredential = async ( contactId, data ) => {
	log( '* update contact' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: `/contacts/${ contactId }/credentials`,
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const deleteCredential = async ( contactId, id ) => {
	log( '* delete contact' );
	const response = await noraApiRequest( {
		method: 'DELETE',
		url: `/contacts/${ contactId }/credentials/${ id }`,
		signal: controller.signal
	} );

	return response.data;
};
